var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutputWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m400 712.5h337.5v187.5c0 76-61.5 137.5-137.5 137.5h-300c-76 0-137.5-61.5-137.5-137.5v-600c0-76 61.5-137.5 137.5-137.5h300c76 0 137.5 61.5 137.5 137.5v187.5h-337.5c-62 0-112.5 50.5-112.5 112.5s50.5 112.5 112.5 112.5zm626.5-139-150-150c-14.648-14.648-38.398-14.648-53.051 0-14.648 14.648-14.648 38.398 0 53.051l86 86h-509.45c-20.699 0-37.5 16.801-37.5 37.5s16.801 37.5 37.5 37.5h509.45l-86 86c-14.648 14.648-14.648 38.398 0 53.051 7.3008 7.3008 16.898 11 26.5 11 9.6016 0 19.199-3.6484 26.5-11l150-150c14.648-14.648 14.648-38.398 0-53.051z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutputWidget);
export default __webpack_public_path__ + "static/media/output-widget.9b0e1057dc96730b5a778b064c5de6bc.svg";
export { ForwardRef as ReactComponent };